import { InfoTooltip, JarbSelect } from "@42.nl/ui";
import useReferenceApi from "@services/api/reference/reference.api";
import useYearStore from "@src/providers/year.store";
import { Loader } from "../components";

interface Props {
  id: string;
  label: string;
  placeholder: string;
  tooltip?: string;
  validator: string;
}

export default function ReferenceTypeSelect({
  id,
  label,
  placeholder,
  tooltip,
  validator
}: Props) {
  const { currentYear } = useYearStore();
  const { useReferenceTypesQuery } = useReferenceApi();
  const state = useReferenceTypesQuery({
    variables: {
      year: currentYear?.externalId
    },
    enabled: !!currentYear
  });

  return (
    <Loader state={state}>
      {(types) => (
        <JarbSelect
          id={id}
          name={id}
          label={
            <>
              <span>{label}</span>
              <InfoTooltip tooltip={tooltip} />
            </>
          }
          placeholder={placeholder}
          options={types.sort()}
          labelForOption={(type) => type}
          jarb={{
            validator,
            label
          }}
        />
      )}
    </Loader>
  );
}
